const TTBH_HEADER = Object.freeze({
  title: {
    disabledKey: 'TTBH_HEADER_TITLE_DISABLED',
    value: 'Try at home or at Pomelo locations',
  },
  subtitle: {
    disabledKey: 'TTBH_HEADER_SUBTITLE_DISABLED',
    value: 'Find your perfect fit',
  },
})

export default TTBH_HEADER
